import * as preact from "preact";
import PropTypes from "prop-types";

import IconDelete from "../../Icons/IconDelete";

import "./style.css";

class RepeatableInputField extends preact.Component {
    state = {
        error: null
    }

    handleChange = event => {
        const { index, onChange } = this.props;

        onChange(index, event.target.value);
    }

    handleDelete = () => {
        const { index, onDelete } = this.props;

        onDelete(index);
    }

    handleBlur = () => {
        const { name, value, validate } = this.props;

        this.setState({
            error: validate(name, value)
        });
    }

    componentWillReceiveProps({ value, name, validate }) {
        if (validate && value !== this.props.value && this.state.error) {
            this.setState({
                error: validate(name, value)
            });
        }
    }

    render() {
        const { error } = this.state;
        const {
            name,
            value,
            placeholder,
            onDelete,
            validate
        } = this.props;

        return (
            <div class="repeatableInputField">
                <div class="fieldWrapper">
                    <input
                        name={name}
                        value={value}
                        placeholder={placeholder}
                        onBlur={validate && this.handleBlur}
                        onInput={this.handleChange}/>
                    {onDelete && <button type="button" class="deleteButton" onClick={this.handleDelete}><IconDelete/></button>}
                </div>
                {!!error && <p class="error">{error}</p>}
            </div>
        );
    }
}

RepeatableInputField.propTypes = {
    name: PropTypes.string.isRequired,
    /** triggered when input value is changed */
    onChange: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
    /** triggered when delete button is clicked */
    onDelete: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
    /** returns error message when input value is not satisfied */
    validate: PropTypes.func,
    value: PropTypes.string,
    placeholder: PropTypes.string
};

export default RepeatableInputField;
